import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Section, Field, ErrorBox } from "@/components/Common";

export function ChangePassword({ admin = false }) {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    if (f.next.length < 8 || !/\d/.test(f.next) || !/[a-z]/i.test(f.next)) return setErr("New password must be at least 8 characters and include letters and numbers.");
    if (f.next !== f.confirm) return setErr("The new passwords do not match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Your password has been changed");
      setF({ current: "", next: "", confirm: "" });
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  };
  return (
    <Section title="Change password" testId="change-password-section">
      <form onSubmit={submit} className="grid gap-4" noValidate>
        <ErrorBox error={err} />
        <Field label="Current password" id="cp-current"><Input id="cp-current" type="password" autoComplete="current-password" value={f.current} onChange={set("current")} data-testid="cp-current-input" /></Field>
        <Field label="New password" id="cp-new" hint={admin ? "At least 8 characters with letters and numbers. For admin accounts we recommend 12+ characters including a symbol." : "At least 8 characters, including letters and numbers."}>
          <Input id="cp-new" type="password" autoComplete="new-password" value={f.next} onChange={set("next")} data-testid="cp-new-input" />
        </Field>
        <Field label="Confirm new password" id="cp-confirm"><Input id="cp-confirm" type="password" autoComplete="new-password" value={f.confirm} onChange={set("confirm")} data-testid="cp-confirm-input" /></Field>
        <Button type="submit" className="w-fit" disabled={busy || !f.current} data-testid="cp-submit-btn">{busy ? "Saving…" : "Change password"}</Button>
      </form>
    </Section>
  );
}
